import { styled } from 'theme';

export const WrapperSkeletonUI = styled('div')(() => ({
  div: {
    marginTop: '17px',
  },
}));
